const isObject = (value) =>
  Boolean(value && typeof value === "object" && !Array.isArray(value));

const getClaimRole = (claims = null) =>
  isObject(claims) ? String(claims.role || "").toLowerCase() : "";

export const summarizeProductClaims = (claims = null) => {
  if (!isObject(claims)) {
    return null;
  }

  const role = getClaimRole(claims);
  const summary = {
    isAdmin: Boolean(claims.isAdmin || claims.admin || role === "admin"),
    isHelper: Boolean(
      claims.isHelper ||
        claims.isEmployee ||
        claims.employee ||
        claims.helper ||
        role === "helper" ||
        role === "employee",
    ),
    isMember: Boolean(claims.isMember || claims.member || role === "member"),
  };

  return Object.values(summary).some(Boolean) ? summary : null;
};

export const getProductRoleFromClaims = (claims = null) => {
  const summary = summarizeProductClaims(claims);

  if (summary?.isAdmin) return "admin";
  if (summary?.isHelper) return "helper";
  if (summary?.isMember) return "member";
  return null;
};
